import { isClinicPortal } from "./portalHost";
import { getPortalByRole } from "./portalTypes";
import { normalizeRole } from "./roles";

export const AUTH_PATH = "/auth";

/** Единая страница входа для всех ролей клуба */
export const UNIFIED_LOGIN_PATH = "/login";

export function getDashboardPath(role) {
  const r = normalizeRole(role);
  if (!isClinicPortal()) {
    switch (r) {
      case "admin":
      case "owner":
        return "/clinic/admin";
      case "trainer":
        return "/clinic/doctor";
      case "client":
        return "/clinic/patient";
      default:
        return "/";
    }
  }
  return getPortalByRole(r).app;
}

export function getLoginPath(role) {
  if (!isClinicPortal()) {
    return AUTH_PATH;
  }
  if (role) {
    return getPortalByRole(role).login;
  }
  return UNIFIED_LOGIN_PATH;
}

export function getAuthPath() {
  return isClinicPortal() ? UNIFIED_LOGIN_PATH : AUTH_PATH;
}
